import React, {useEffect, useState} from 'react';
import './ScrollToTopButtonComponent.css';

const ScrollToTopButtonComponent = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 200) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <>
            {isVisible && (
                <button className="scroll-to-top-button" onClick={scrollToTop} title="Scroll up">
                    <i className="fa fa-caret-up scroll-to-top-icon" aria-hidden="true"></i>
                </button>
            )}
        </>
    );
};
export default ScrollToTopButtonComponent;
